import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ReInstallIcon extends BaseIcon {

  getChildren = () => {
    const color = this.getColor() === 'currentColor' ? '#2e3f58' : this.getColor()
    return [
      <path data-name="re-install icon" d="M7 10.412a3.5 3.5 0 1 1 3.5 3.5 3.5 3.5 0 0 1-3.5-3.5Zm3.33 2.1h1.132a.8.8 0 0 0 .116.011.6.6 0 0 0 .085-.008l.053-.006h.013a1.582 1.582 0 0 0 0-3.151v-.003H9.618V8.291L7.866 9.7l1.752 1.425V10.05h1.769l.054.013a.217.217 0 0 1 .04 0H11.552a.891.891 0 0 1 .176 1.765h-1.4Zm-4.205-.354A6.087 6.087 0 0 1 0 6.038 5.94 5.94 0 0 1 6.038 0a6.087 6.087 0 0 1 6.124 6.125v.35a5.088 5.088 0 0 0-1.575-.35.8.8 0 0 0-.175-.875.846.846 0 0 0-1.225 0L7 7.438v-4.9a.827.827 0 0 0-.875-.875.826.826 0 0 0-.875.875v4.9L2.975 5.25a.847.847 0 0 0-1.225 0 .847.847 0 0 0 0 1.225l3.762 3.675a.792.792 0 0 0 .613.263 3.922 3.922 0 0 0 .35 1.75Z" fill={color}/>
    ]
  }
  getViewBox = () => '0 0 14 13.913'
}
